
export class GetLeadEventsFilter {
  userIds: string[];
  companyIds: string[];
  dateFrom: Date;
  dateTo: Date;
  isNotPlanning?: boolean;
  leadId?: string;
  isPlanningReminder: boolean;
  isPlanningDay: boolean;
}
